import {
  FilterOptions,
  IFilterComparator,
  DateRangeFilterModel
} from '../filter-types';
import { CalendarGridColumnName } from '../../../grid/types/column.types';
import { SeriesFilterHandler } from './base/series-filter-handler';
import { DateRangeModelComparator } from './comparators/date-range-model-comparator';

export class FirstCouponDateFilterHandler extends SeriesFilterHandler {
  private comparator: DateRangeModelComparator;

  get name(): string {
    return CalendarGridColumnName.FirstCouponDate;
  }

  hasValidDiff(
    options: FilterOptions,
    grid: Partial<DateRangeFilterModel>,
    store: DateRangeFilterModel
  ): boolean {
    return this.getValidDiffComparator(options).hasValidDiff(grid, store);
  }

  getValidDiffComparator(
    options: FilterOptions
  ): IFilterComparator<DateRangeFilterModel> {
    if (!this.comparator) {
      this.comparator = new DateRangeModelComparator();
    }
    return this.comparator;
  }
}
